<template>
  <n-modal class="card-record" :loading="$var('load')" @close="$emit('close')">
    <h2>
      Запись в журнале
      <span v-if="edit.records" style="float: right; font-size: .8rem"><n-button icon="trash" @click="remove" /></span>
    </h2>
    <div class="body">
      <div class="object">Проект: {{ project.title }}</div>
      <div>Статус: {{ utils.status(record.status) }}</div>
      <div>Автор: {{ record.author.fullName }}</div>

      <n-button v-if="edit.records" @click="finish">Подписать</n-button>
    </div>
    <br />
    <n-items>
      <n-select :data="data" title="Фамилия, имя отчество" v-bind="$form.input('user', 'select')" :disabled="!edit.records" />
      <n-input title="Разряд квалификационный" v-bind="$form.input('class')" :text="!edit.records" />
      <n-input title="Номер личного клейма" v-bind="$form.input('stamp')" :text="!edit.records" />
      <n-input title="Удостоверение на право производства сварочных работ: Номер" v-bind="$form.input('number')" :text="!edit.records" />
      <n-input title="Удостоверение на право производства сварочных работ: срок действия" v-bind="$form.input('expiringTime')" :text="!edit.records" />
      <n-input title="Удостоверение на право производства сварочных работ: допущен к сварке (швов в пространственном положении)" v-bind="$form.input('availableTo')" :text="!edit.records" />
      <n-input title="Отметка о сварке пробных и контрольных образцов" v-bind="$form.input('resultMark')" :text="!edit.records" />
    </n-items>

    <br />
    <n-divide>
      <n-button v-if="edit.records" color="success" @click="save">Сохранить</n-button>
      <n-button @click="$emit('close')">Закрыть</n-button>
    </n-divide>
  </n-modal>
</template>

<script>
import utils from 'utils'
import CModalJournalDoSign from 'components/journal/ModalDoSign'

export default {
  name: 'ModalRecord',
  components: { CModalJournalDoSign, },
  props: [ 'project', 'journal', ],
  data() {
    return {
      utils,
      record: { author: {}, },
      user: $app.auth.user(),
      data: [],
      tabs: [
        { name: 'info', title: 'Информация', callback: this.save, },
        { name: 'control', title: 'Проверяющие', },
      ],
      columns: [
        { title: 'Название', name: 'title', },
        { title: 'Расход', name: 'done', },
      ],
      translates: {
        attach: 'Приложения',
        schema: 'Исполнительные схемы',
        figure: 'Чертежи',
        input: 'Документы',
      },
    }
  },
  computed: {
    id() {
      return this.$route.query.show
    },
    edit() {
      return {
        records: this.record.status === 'formed' && $app.auth.can('journals_welding_records', this.project.id),
      }
    },
  },
  watch: {
    '$route.query.id'() {
      this.load()
    },
  },
  created() {
    this.load()
    this.loadPeople()
    this.$form.init({})
  },
  methods: {
    loadPeople() {
      this.$var('load', true)
      $api.data.get(this.project.id, 'participants,executor,sub,all').then((response) => {
        this.data = response.data.content
        this.record.user = $n.find(response.data.content[0].children, (e) => {
          if (e.title === this.record.name) {
            return e
          }
        })
        this.$form.init(this.record)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    load() {
      this.$var('load', true)
      $api.journals.welding.three.get(this.project.id, this.id).query({
        'with[author][with][participation]': null,
        projectId: this.project.id,
      }).then((result) => {
        this.record = result.data.content
        this.loadPeople()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    finish() {
      this.$var('load', true)
      $api.journals.welding.three.finish(this.record.id).then((result) => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    save() {
      const data = {
        record: this.$form.get(),
      }
      data.record.name = this.$form.get('user.title')
      this.$var('load', true)
      $api.journals.welding.three.edit(this.record.id, this.$form.get()).then(() => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    remove() {
      this.$var('load', true)
      $api.journals.records.welding.three.remove(this.record.id).then(() => {
        this.load()
        this.$emit('close')
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.card-record {
  
  .weather {
    .env, .temperature, .wind {
      width: 150px;
      margin-right: 20px;
    }
  }
  

}
</style>
